"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.roundTo = void 0;
/**
 * @deprecated This function is deprecated in favor of round.
 */
const roundTo = (decimalPlaces) => (n) => parseFloat(n.toFixed(decimalPlaces));
exports.roundTo = roundTo;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicm91bmQtdG8uanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvdXRpbHMvcm91bmQtdG8udHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQUE7O0dBRUc7QUFDSSxNQUFNLE9BQU8sR0FBRyxDQUFDLGFBQXFCLEVBQUUsRUFBRSxDQUFDLENBQUMsQ0FBUyxFQUFFLEVBQUUsQ0FDOUQsVUFBVSxDQUFDLENBQUMsQ0FBQyxPQUFPLENBQUMsYUFBYSxDQUFDLENBQUMsQ0FBQztBQUQxQixRQUFBLE9BQU8sV0FDbUIifQ==